export default "__VITE_ASSET__B3K8uS6u__"